/**
 * set menu up ready for splide
 */
import Splide from '@splidejs/splide';

(() => {
  const catBoxes = document.querySelector('.js-cat-splide');
  if (!catBoxes) return;

  catBoxes.classList.remove('hide');
  const splideTrack = document.createElement('div');
  splideTrack.classList.add('splide__track');
  const splideList = catBoxes.querySelector('ul.hasSubmenus');
  splideList.classList.add('splide__list');

  splideTrack.appendChild(splideList);
  catBoxes.appendChild(splideTrack);

  const splideSlides = splideList.querySelectorAll('.has-submenu');
  splideSlides.forEach((slide) => {
    slide.classList.add('splide__slide');

    const shopAll = slide.querySelector('a').cloneNode(true);
    shopAll.textContent = 'Shop All';
    shopAll.classList.add('shop-all');
    slide.querySelector('.submenu').append(shopAll);

    slide.querySelector('.submenu').prepend(slide.querySelector('a')); // move title into overlay

    slide.append(slide.querySelector('.bg-img')); // move bg out of overlay
  });
})();

(() => {
  document.querySelectorAll('.js-cat-splide').forEach((item) => {
    const arrowsEight = item.children.length >= 8;

    const slider = new Splide(item, {
      type: 'slide',
      perPage: 7,
      perMove: 1,
      gap: 20,
      pagination: false,
      arrows: arrowsEight,
      autoplay: false,
      breakpoints: {
        1860: {
          perPage: 6,
          pagination: true,
          arrows: true,
        },
        1400: {
          perPage: 4,
        },
        940: {
          perPage: 2,
        },
        481: {
          perPage: 1,
        },
      },
    });
    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
